import React from 'react';
import { Container, Typography, Box, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { communityBoards } from '../../data/communityBoards';

const CommunityPage = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          커뮤니티
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          다양한 주제로 소통하고 정보를 공유하세요.
        </Typography>
        <Grid container spacing={3}>
          {communityBoards.map((board, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Box
                onClick={() => navigate(board.link)}
                sx={{
                  p: 3,
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 1,
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: 'action.hover'
                  }
                }}
              >
                {board.icon}
                <Typography variant="h6" gutterBottom>
                  {board.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {board.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default CommunityPage; 